import { CircularProgress } from "@mui/material";
import { RouterProvider } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { router } from "./config/router";
import { AppThemeProvider } from "./providers/components";

function App() {
  const [currentPathName, setCurrentPathName] = useState<string>("");

  useEffect(() => {
    setCurrentPathName(router.history.location.pathname);

    router.history.subscribe(() => {
      setCurrentPathName(router.history.location.pathname);
    });
  }, []);

  return (
    <AppThemeProvider pathname={currentPathName}>
      <RouterProvider
        router={router}
      />
    </AppThemeProvider>
  );
}

export default App;
